import { render, staticRenderFns } from "./inventory-items.vue?vue&type=template&id=b8d7a8f4&"
import script from "./inventory-items.vue?vue&type=script&lang=js&"
export * from "./inventory-items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports